/**
 * Holds the short-lived Sanctum access token in memory only — never
 * localStorage/sessionStorage (see docs/IMPLEMENTATION_PLAN.md
 * section 5.1: this limits what an XSS payload could exfiltrate to a
 * value that dies with the tab, rather than a persistent credential).
 *
 * This is a plain module-level variable, not React state, so
 * src/api/client.ts can read/write it without importing React or
 * creating a dependency cycle with AuthContext. AuthContext is the only
 * thing that should call `setAccessToken`/`clearAccessToken` in
 * practice — everything else should go through `useAuth()`.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}
